export const Colors = {
  default: {
    light: {
      background: "oklch(1 0 0)",
      foreground: "oklch(0.13 0.028 261.692)",
      card: "oklch(1 0 0)",
      "card-foreground": "oklch(0.13 0.028 261.692)",
      popover: "oklch(1 0 0)",
      "popover-foreground": "oklch(0.13 0.028 261.692)",
      primary: "oklch(0.21 0.034 264.665)",
      "primary-foreground": "oklch(0.985 0.002 247.839)",
      secondary: "oklch(0.967 0.003 264.542)",
      "secondary-foreground": "oklch(0.21 0.034 264.665)",
      muted: "oklch(0.967 0.003 264.542)",
      "muted-foreground": "oklch(0.551 0.027 264.364)",
      accent: "oklch(0.967 0.003 264.542)",
      "accent-foreground": "oklch(0.21 0.034 264.665)",
      destructive: "oklch(0.577 0.245 27.325)",
      border: "oklch(0.928 0.006 264.531)",
      input: "oklch(0.928 0.006 264.531)",
      ring: "oklch(0.707 0.022 261.325)",
      "chart-1": "oklch(0.646 0.222 41.116)",
      "chart-2": "oklch(0.6 0.118 184.704)",
      "chart-3": "oklch(0.398 0.07 227.392)",
      "chart-4": "oklch(0.828 0.189 84.429)",
      "chart-5": "oklch(0.769 0.188 70.08)",
      radius: "0.625rem",
      sidebar: "oklch(0.985 0.002 247.839)",
      "sidebar-foreground": "oklch(0.13 0.028 261.692)",
      "sidebar-primary": "oklch(0.21 0.034 264.665)",
      "sidebar-primary-foreground": "oklch(0.985 0.002 247.839)",
      "sidebar-accent": "oklch(0.967 0.003 264.542)",
      "sidebar-accent-foreground": "oklch(0.21 0.034 264.665)",
      "sidebar-border": "oklch(0.928 0.006 264.531)",
      "sidebar-ring": "oklch(0.707 0.022 261.325)",
    },
    dark: {
      background: "oklch(0.13 0.028 261.692)",
      foreground: "oklch(0.985 0.002 247.839)",
      card: "oklch(0.21 0.034 264.665)",
      "card-foreground": "oklch(0.985 0.002 247.839)",
      popover: "oklch(0.21 0.034 264.665)",
      "popover-foreground": "oklch(0.985 0.002 247.839)",
      primary: "oklch(0.928 0.006 264.531)",
      "primary-foreground": "oklch(0.21 0.034 264.665)",
      secondary: "oklch(0.278 0.033 256.848)",
      "secondary-foreground": "oklch(0.985 0.002 247.839)",
      muted: "oklch(0.278 0.033 256.848)",
      "muted-foreground": "oklch(0.707 0.022 261.325)",
      accent: "oklch(0.278 0.033 256.848)",
      "accent-foreground": "oklch(0.985 0.002 247.839)",
      destructive: "oklch(0.704 0.191 22.216)",
      border: "oklch(1 0 0 / 10%)",
      input: "oklch(1 0 0 / 15%)",
      ring: "oklch(0.551 0.027 264.364)",
      "chart-1": "oklch(0.488 0.243 264.376)",
      "chart-2": "oklch(0.696 0.17 162.48)",
      "chart-3": "oklch(0.769 0.188 70.08)",
      "chart-4": "oklch(0.627 0.265 303.9)",
      "chart-5": "oklch(0.645 0.246 16.439)",
      sidebar: "oklch(0.21 0.034 264.665)",
      "sidebar-foreground": "oklch(0.985 0.002 247.839)",
      "sidebar-primary": "oklch(0.488 0.243 264.376)",
      "sidebar-primary-foreground": "oklch(0.985 0.002 247.839)",
      "sidebar-accent": "oklch(0.278 0.033 256.848)",
      "sidebar-accent-foreground": "oklch(0.985 0.002 247.839)",
      "sidebar-border": "oklch(1 0 0 / 10%)",
      "sidebar-ring": "oklch(0.551 0.027 264.364)",
    },
  },
  yellow: {
    light: {
      background: "oklch(1 0 0)",
      foreground: "oklch(0.13 0.028 261.692)",
      card: "oklch(1 0 0)",
      "card-foreground": "oklch(0.13 0.028 261.692)",
      popover: "oklch(1 0 0)",
      "popover-foreground": "oklch(0.13 0.028 261.692)",
      primary: "oklch(0.91 0.18 95)", // yellow-400
      "primary-foreground": "oklch(0.2 0.05 95)", // dark text on yellow
      secondary: "oklch(0.97 0.05 95)", // soft yellow
      "secondary-foreground": "oklch(0.25 0.06 95)",
      muted: "oklch(0.96 0.04 95)",
      "muted-foreground": "oklch(0.55 0.06 95)",
      accent: "oklch(0.95 0.06 95)",
      "accent-foreground": "oklch(0.25 0.06 95)",
      destructive: "oklch(0.577 0.245 27.325)", // red-600
      border: "oklch(0.928 0.006 264.531)",
      input: "oklch(0.928 0.006 264.531)",
      ring: "oklch(0.85 0.14 95)", // vibrant yellow ring
      "chart-1": "oklch(0.91 0.18 95)", // yellow
      "chart-2": "oklch(0.646 0.222 41.116)", // orange
      "chart-3": "oklch(0.6 0.118 184.704)", // teal
      "chart-4": "oklch(0.398 0.07 227.392)", // cyan
      "chart-5": "oklch(0.769 0.188 70.08)", // amber
      radius: "0.625rem",
      sidebar: "oklch(0.985 0.002 247.839)",
      "sidebar-foreground": "oklch(0.13 0.028 261.692)",
      "sidebar-primary": "oklch(0.91 0.18 95)",
      "sidebar-primary-foreground": "oklch(0.2 0.05 95)",
      "sidebar-accent": "oklch(0.97 0.05 95)",
      "sidebar-accent-foreground": "oklch(0.25 0.06 95)",
      "sidebar-border": "oklch(0.928 0.006 264.531)",
      "sidebar-ring": "oklch(0.85 0.14 95)",
    },
    dark: {
      background: "oklch(0.13 0.028 261.692)",
      foreground: "oklch(0.985 0.002 247.839)",
      card: "oklch(0.21 0.034 264.665)",
      "card-foreground": "oklch(0.985 0.002 247.839)",
      popover: "oklch(0.21 0.034 264.665)",
      "popover-foreground": "oklch(0.985 0.002 247.839)",
      primary: "oklch(0.85 0.14 95)", // yellow-500
      "primary-foreground": "oklch(0.2 0.05 95)", // dark text
      secondary: "oklch(0.35 0.05 95)", // muted yellow background
      "secondary-foreground": "oklch(0.985 0.002 247.839)",
      muted: "oklch(0.35 0.05 95)",
      "muted-foreground": "oklch(0.707 0.022 261.325)",
      accent: "oklch(0.4 0.07 95)",
      "accent-foreground": "oklch(0.985 0.002 247.839)",
      destructive: "oklch(0.704 0.191 22.216)",
      border: "oklch(1 0 0 / 10%)",
      input: "oklch(1 0 0 / 15%)",
      ring: "oklch(0.85 0.14 95)",
      "chart-1": "oklch(0.85 0.14 95)", // yellow
      "chart-2": "oklch(0.696 0.17 162.48)", // emerald
      "chart-3": "oklch(0.769 0.188 70.08)", // amber
      "chart-4": "oklch(0.627 0.265 303.9)", // purple
      "chart-5": "oklch(0.645 0.246 16.439)", // rose
      sidebar: "oklch(0.21 0.034 264.665)",
      "sidebar-foreground": "oklch(0.985 0.002 247.839)",
      "sidebar-primary": "oklch(0.85 0.14 95)",
      "sidebar-primary-foreground": "oklch(0.2 0.05 95)",
      "sidebar-accent": "oklch(0.35 0.05 95)",
      "sidebar-accent-foreground": "oklch(0.985 0.002 247.839)",
      "sidebar-border": "oklch(1 0 0 / 10%)",
      "sidebar-ring": "oklch(0.85 0.14 95)",
    },
  },
  rose: {
    light: {
      background: "oklch(1 0 0)",
      foreground: "oklch(0.2 0.02 20)",
      card: "oklch(1 0 0)",
      "card-foreground": "oklch(0.2 0.02 20)",
      popover: "oklch(1 0 0)",
      "popover-foreground": "oklch(0.2 0.02 20)",
      primary: "oklch(0.65 0.23 20)",
      "primary-foreground": "oklch(1 0 0)",
      secondary: "oklch(0.95 0.04 20)",
      "secondary-foreground": "oklch(0.2 0.02 20)",
      muted: "oklch(0.96 0.03 20)",
      "muted-foreground": "oklch(0.55 0.05 20)",
      accent: "oklch(0.92 0.04 20)",
      "accent-foreground": "oklch(0.2 0.02 20)",
      destructive: "oklch(0.55 0.24 25)",
      border: "oklch(0.92 0.02 20)",
      input: "oklch(0.92 0.02 20)",
      ring: "oklch(0.65 0.23 20)",
      "chart-1": "oklch(0.67 0.23 20)",
      "chart-2": "oklch(0.75 0.2 340)",
      "chart-3": "oklch(0.6 0.18 30)",
      "chart-4": "oklch(0.8 0.2 70)",
      "chart-5": "oklch(0.7 0.15 310)",
      radius: "0.625rem",
      sidebar: "oklch(0.98 0.01 20)",
      "sidebar-foreground": "oklch(0.2 0.02 20)",
      "sidebar-primary": "oklch(0.65 0.23 20)",
      "sidebar-primary-foreground": "oklch(1 0 0)",
      "sidebar-accent": "oklch(0.95 0.04 20)",
      "sidebar-accent-foreground": "oklch(0.2 0.02 20)",
      "sidebar-border": "oklch(0.92 0.02 20)",
      "sidebar-ring": "oklch(0.65 0.23 20)",
    },
    dark: {
      background: "oklch(0.2 0.02 20)",
      foreground: "oklch(0.98 0.01 20)",
      card: "oklch(0.25 0.03 20)",
      "card-foreground": "oklch(0.98 0.01 20)",
      popover: "oklch(0.25 0.03 20)",
      "popover-foreground": "oklch(0.98 0.01 20)",
      primary: "oklch(0.72 0.2 20)",
      "primary-foreground": "oklch(0.25 0.03 20)",
      secondary: "oklch(0.35 0.05 20)",
      "secondary-foreground": "oklch(0.98 0.01 20)",
      muted: "oklch(0.35 0.05 20)",
      "muted-foreground": "oklch(0.65 0.08 20)",
      accent: "oklch(0.35 0.05 20)",
      "accent-foreground": "oklch(0.98 0.01 20)",
      destructive: "oklch(0.6 0.22 25)",
      border: "oklch(1 0 0 / 12%)",
      input: "oklch(1 0 0 / 16%)",
      ring: "oklch(0.72 0.2 20)",
      "chart-1": "oklch(0.67 0.23 20)",
      "chart-2": "oklch(0.75 0.2 340)",
      "chart-3": "oklch(0.6 0.18 30)",
      "chart-4": "oklch(0.8 0.2 70)",
      "chart-5": "oklch(0.7 0.15 310)",
      sidebar: "oklch(0.25 0.03 20)",
      "sidebar-foreground": "oklch(0.98 0.01 20)",
      "sidebar-primary": "oklch(0.72 0.2 20)",
      "sidebar-primary-foreground": "oklch(0.98 0.01 20)",
      "sidebar-accent": "oklch(0.35 0.05 20)",
      "sidebar-accent-foreground": "oklch(0.98 0.01 20)",
      "sidebar-border": "oklch(1 0 0 / 12%)",
      "sidebar-ring": "oklch(0.72 0.2 20)",
    },
  },
} as const;
